import React from "react";
import axios from "axios";
import Form from "react-validation/build/form";

import { BACKEND_CONFIG } from "../../config/consts";
import Input from "../../components/Input";
import { required, zipCodeValidator } from "../../validation/validation";
import DropDown from "../../components/DropDown";
import { ValidationProvider } from "../../validation/validation-provider";

import "../../styles/collect-payment-page.scss";

export class NewAddress extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      frontErrors: null,
      states: [],
      address1: null,
      address2: null,
      zip: null,
      city: null,
      state: "",
    };

    this.updateData = this.updateData.bind(this);

    this.formRef = React.createRef();
  }

  componentDidMount() {
    axios.get(`${BACKEND_CONFIG.apiUrl}listitems?keys=state`).then((data) => {
      this.setState({
        states: data.data.filter((d) => d.Key === "state")[0].Value,
      });
    });
  }

  updateData = (e) => {
    const field = e.target.name;

    this.setState({ [field]: e.target.value });
  };

  render() {
    return (
      <div>
        <Form ref={this.formRef}>
          <div className="form-group">
            <label htmlFor="billing-address-address1">Address Line 1</label>
            <Input
              value={this.state.address1}
              type="text"
              id="billing-address-address1"
              name="address1"
              onBlur={this.updateData}
              validations={[required]}
            />
          </div>
          <div className="form-group">
            <label htmlFor="billing-address-address2">Address Line 2</label>
            <Input
              value={this.state.accountHolderMiddleInitial}
              type="text"
              id="billing-address-address2"
              name="address2"
              onBlur={this.updateData}
            />
          </div>
          <div className="form-group">
            <label htmlFor="billing-address-zip">Zip Code</label>
            <Input
              value={this.state.zip}
              type="text"
              id="billing-address-zip"
              name="zip"
              maxLength="5"
              onBlur={this.updateData}
              validations={[required, zipCodeValidator]}
            />
          </div>
          <div className="form-group">
            <label htmlFor="billing-address-city">City</label>
            <Input
              value={this.state.city}
              type="text"
              id="billing-address-city"
              name="city"
              onBlur={this.updateData}
              validations={[required]}
            />
          </div>
          <div className="form-group">
            <label htmlFor="billing-address-state">State</label>
            <DropDown
              id="billing-address-state"
              listOptions={this.state.states}
              name="state"
              placeholder="Select"
              value={this.state.state}
              onBlur={this.updateData}
              validations={[required]}
            />
          </div>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            className="btn btn-primary btn-primary-small"
            style={{ marginTop: "20px" }}
            onClick={() => {
              var isValid = ValidationProvider.isValid(this.formRef);
              if (!isValid) {
                return;
              }
              this.props.submitAddress({
                address1: this.state.address1,
                address2: this.state.address2,
                zip: this.state.zip,
                city: this.state.city,
                state: this.state.state,
              });
            }}
          >
            Use This Address
          </a>
        </Form>
      </div>
    );
  }
}
